export const TEST_NAME_COLUMN_STYLE = { width: '180px', maxWidth: '180px' } as const;
